import { render, staticRenderFns } from "./PayFastCard.vue?vue&type=template&id=1ec26f9b&scoped=true&"
import script from "./PayFastCard.vue?vue&type=script&lang=js&"
export * from "./PayFastCard.vue?vue&type=script&lang=js&"
import style0 from "./PayFastCard.vue?vue&type=style&index=0&id=1ec26f9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec26f9b",
  null
  
)

export default component.exports